import React from 'react';

import ToggleItem from '../../../modules/toggle-item/toggle-item';
import { SORT_DIRECTION } from '../../../types';

import './order-realizations-adjusted-sorts.scss';

interface OrderRealizationsAdjustedSortsProps {
  onItemToggle: (
    name: 'oldCount' | 'sum' | 'count' | 'oldSum',
    direction: SORT_DIRECTION
  ) => void;
  directions: {
    count: SORT_DIRECTION;
    sum: SORT_DIRECTION;
    oldCount: SORT_DIRECTION;
    oldSum: SORT_DIRECTION;
  };
}

const OrderRealizationsAdjustedSorts: React.FC<OrderRealizationsAdjustedSortsProps> = ({
  directions,
  onItemToggle,
}) => (
  <div className="realization-adjust__sort">
    <div className="realization-adjust__sort-list">
      <div className="realization-adjust__sort-item realization-adjust__sort-item--title">
        <ToggleItem title="Название" />
      </div>
      <div className="realization-adjust__sort-item realization-adjust__sort-item--count-old">
        <ToggleItem
          title="Старое кол-во"
          direction={directions.oldCount}
          onChangeToggle={(direction) => onItemToggle('oldCount', direction)}
          toggle
        />
      </div>
      <div className="realization-adjust__sort-item realization-adjust__sort-item--count">
        <ToggleItem
          title="Кол-во"
          direction={directions.count}
          onChangeToggle={(direction) => onItemToggle('count', direction)}
          toggle
        />
      </div>
      <div className="realization-adjust__sort-item realization-adjust__sort-item--price-old">
        <ToggleItem
          title="Старая цена"
          direction={directions.oldSum}
          onChangeToggle={(direction) => onItemToggle('oldSum', direction)}
          toggle
        />
      </div>
      <div className="realization-adjust__sort-item realization-adjust__sort-item--price">
        <ToggleItem
          title="Новая цена"
          direction={directions.sum}
          onChangeToggle={(direction) => onItemToggle('sum', direction)}
          toggle
        />
      </div>
    </div>
  </div>
);

export default OrderRealizationsAdjustedSorts;
